module.exports = __webpack_public_path__ + "img/bljqr2.66d14bf8.jpg";